import { useBranchConfiguration } from '@/hooks/useBranchConfiguration.ts';

export const useDigitalOrderingEnabled = (
  brandId: string | undefined,
  outletId: string | undefined
) => {
  return useBranchConfiguration({
    brandId,
    outletId,
    select: data => data.digitalOrderingEnabled,
  });
};
